import { Image } from '@ldfeplatform/componentlibrary.ui.atoms.image';
import { Link } from '@ldfeplatform/componentlibrary.ui.atoms.link';
import { Headline } from '@ldfeplatform/componentlibrary.ui.molecules.headline';
import { chevronLeftIcon } from 'Data/constants';
import { useRouter } from 'next/router';
import React from 'react';
import { useIntl } from 'react-intl';
import styles from './pharmaprix-owners-header.module.scss';

const PharmaprixOwnersHeader: React.FC = () => {
  const { formatMessage } = useIntl();
  const router = useRouter();

  return (
    <div className={styles.headerWrapper}>
      <Link onClick={() => router.back()} className={styles.header}>
        <div className={styles.headerLink}>
          <Image
            src={chevronLeftIcon}
            alt={formatMessage({ id: 'backToPhx' })}
            data-testid="pharmaprix-header-chevron-image"
          />
          {formatMessage({ id: 'backToPhx' })}
        </div>
        <Image
          className={styles.headerLogo}
          src={
            'https://dis-prod.assetful.loblaw.ca/content/dam/loblaw-companies-limited/creative-assets/sdmi/2023/evergreen/masthead/Pharmaprix%20logo.svg'
          }
          alt={formatMessage({ id: 'backToPhx' })}
          data-testid="pharmaprix-header-logo-image"
        />
      </Link>
      <Headline
        title={formatMessage({ id: 'pharmaprixPharmacistsOwnersHeaderText' })}
        data-testid="pharmaprix-pharmacists-owners-headline"
        headlineSize={1}
        className={styles.headline}
      />
    </div>
  );
};

export default PharmaprixOwnersHeader;
